module.exports = __webpack_public_path__ + "assets/img/member-empty.47c6a4f9.png";